import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';



const OverviewRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/overview" */
    'routes/Extensions/Prompt/OverviewRoute'
  )
));

const ConnectionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/connections" */
    'routes/Extensions/Prompt/ConnectionsRoute'
  )
));

const AnalyticsDashboardRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/analytics-dashboard" */
    'routes/Extensions/Prompt/AnalyticsDashboardRoute'
  )
));

const PromptsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/index" */
    'routes/Extensions/Prompt/PromptsRoute'
  )
));

const UpdatePromptRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/update" */
    'routes/Extensions/Prompt/UpdatePromptRoute'
  )
));

const AnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/analytics" */
    'routes/Extensions/Prompt/AnalyticsRoute'
  )
));

const SalesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/sales" */
    'routes/Extensions/Prompt/SalesRoute'
  )
));

const ResponsesRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/responses" */
    'routes/Extensions/Prompt/ResponsesRoute'
  )
));

const SyncLogsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/sync-logs" */
    'routes/Extensions/Prompt/SyncLogsRoute'
  )
));

const PreviewRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/prompt/preview" */
    'routes/Extensions/Prompt/PreviewRoute'
  )
));


const getPromptRoutes = () => {
  return [
    {path: paths.getPathPromptOverview(), component: OverviewRoute},
    {path: paths.getPathPromptAnalyticsDashboard(), component: AnalyticsDashboardRoute},
    {path: paths.getPathPromptConnections(), component: ConnectionsRoute},

    {path: paths.getPathPrompts(), component: PromptsRoute},
    {path: paths.getPathAddPrompt(), component: UpdatePromptRoute},
    {path: paths.getPathEditPrompt(":promptId"), component: UpdatePromptRoute},
    {path: paths.getPathReplicatePrompt(":promptId"), render: (props) => <UpdatePromptRoute {...props} isReplicate={true} />},

    {path: paths.getPathPromptAnalytics(":promptId"), component: AnalyticsRoute},
    {path: paths.getPathPromptSales(":promptId"), component: SalesRoute},
    {path: paths.getPathPromptResponses(":promptId"), component: ResponsesRoute},
    {path: paths.getPathPromptSyncLogs(":promptId"), component: SyncLogsRoute},

    {path: paths.getPathPromptPreview(":promptId"), component: PreviewRoute},
  ]
}


export { getPromptRoutes };
